module.exports = __webpack_public_path__ + "static/media/ehealth_calculator_banner_desktop.6fe40fcc.png";